import {
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { stringConstants } from '../../constants/stringConstants';
import { useHistory } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
const schema = Yup.object().shape({
  is_public: Yup.string(),
  title: Yup.string().required(stringConstants.requiredValidationMsg),
  version: Yup.string().required(stringConstants.requiredValidationMsg),
  description: Yup.string().nullable()
      .max(256, `Description can not be more than 256 characters`),
});
export const ReportForm = ({type, data, closePopup}) => {
  const history = useHistory();
  const [reportAction, commonAction] = useStoreActions((actions) => [actions.report,actions.common]);
  const [formData, setFormData] = useState({
    is_public: 'y',
    title: '',
    version: '',
    description: '',
  })
  useEffect(()=>{
    if(type ==  'Edit'){
      console.log(data);
      setFormData({is_public: data.is_public,
      title: data.title,
      version: data.version,
      description: data.description});
    }
  },[data]);
  const onFormSubmit = (values) => {
    if(type == "Edit"){
      reportAction.updateCustomReportMetaData({PK:data.PK ,values}).then((res)=>{
        reportAction.setCustomReport(res.data.data);
        commonAction.setSubmitSnackbar({
          status: true,
          messages: 'Record Updated'
        });
        closePopup();
      }).catch(err=>{
        const errorMessage = err?.response?.data?.error
            .map((error) => Object.values(error))
            .join('<br/>');
        commonAction.setSubmitSnackbar({
          status: true,
          messages: errorMessage,
          error: true
        });
      });
    }else{
      reportAction.postCustomReportMetaData(values).then((res) => {
        history.push(
          '/reports/'+encodeURIComponent(res.data.data.PK),
        );
      }).catch(err=>{
        const errorMessage = err?.response?.data?.error
            .map((error) => Object.values(error))
            .join('<br/>');
        commonAction.setSubmitSnackbar({
          status: true,
          messages: errorMessage,
          error: true
        });
      });
    }
    
  };
  
  return (
    <Formik
      onSubmit={onFormSubmit}
      validationSchema={schema}
      initialValues={formData}
      enableReinitialize={true}
    >
      {(formikProps) => {
        const {
          handleSubmit,
          values,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              style={{ padding: '20px 40px' }}
              justifyContent="center"
            >
              <Grid item sm={10}>
                <Typography variant="h4">{type || 'Add'} Report</Typography>
              </Grid>
              <Grid item sm={2}>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      data-testid="current_status_lable"
                      control={
                        <Switch
                          color="primary"
                          name="is_public"
                          data-testid="is_public"
                          checked={values.is_public == 'n' ? false : true}
                          onChange={(event) => {
                            setFieldValue(
                              'is_public',
                              values.is_public == 'n' ? 'y' : 'n',
                              true,
                            );
                          }}
                        />
                      }
                      label={values.is_public =='n'?"Private":"Public"}
                      className="switchLabel"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item sm={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="name"
                  name="title"
                  label="Name"
                  variant="outlined"
                  value={values.title}
                  onChange={(e, v) => {
                    setFieldValue('title', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.title && touched.title}
                  helperText={errors.title && touched.title && errors.title}
                ></TextField>
              </Grid>
              <Grid item sm={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="version"
                  name="version"
                  label="Version"
                  variant="outlined"
                  value={values.version}
                  onChange={(e, v) => {
                    setFieldValue('version', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.version && touched.version}
                  helperText={
                    errors.version && touched.version && errors.version
                  }
                ></TextField>
              </Grid>
              <Grid item sm={12}>
                <TextField
                  margin="normal"
                  multiline
                  fullWidth
                  id="description"
                  name="description"
                  rows="3"
                  label="Description"
                  variant="outlined"
                  value={values.description}
                  onChange={(e, v) => {
                    setFieldValue('description', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.description && touched.description}
                  helperText={
                    errors.description &&
                    touched.description &&
                    errors.description
                  }
                ></TextField>
              </Grid>
              <Grid item sm={8}>
                <Grid container spacing={2} style={{marginTop: 10}}>
                  <Grid item sm={6}>
                    <Button
                      type="button"
                      variant="contained"
                      color="secondary"
                      value="Cancel"
                      onClick={(e) => {closePopup()}}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item sm={6}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      value="Cancel"
                      onClick={(e) => {}}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
};
